import { render, staticRenderFns } from "./addAddressModal.vue?vue&type=template&id=3809e935&"
import script from "./addAddressModal.vue?vue&type=script&lang=js&"
export * from "./addAddressModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports